export default {
  aditionalData: {
    celular: '',
    email: '',
    state: '',
    city: ''
  },
  clientPhoto: [],
  identityPhoto: [],
  registration: {
    tipoIdentificacion: 'CC',
    identificacion: '',
    primerNombre: '',
    segundoNombre: '',
    primerApellido: '',
    segundoApellido: '',
    fechaNacimiento: '',
    fechaExpedicionDoc: '',
    expedicion: '',
    genero: 'M',
    idCliente: null,
    idCredito: null
  },
  simulation: {
    cliente: {
      nombres: '',
      identificacion: '',
      tipoIdentificacion: ''
    }
  }
}
